import { SEPARATOR } from '@hakimo-ui/hakimo/data-access';
import {
  LocationFilterValue,
  TimeFilterValue,
  TimePeriod,
} from '@hakimo-ui/hakimo/types';
import { getMHFromTimePeriod, getStartEndTimes } from '@hakimo-ui/hakimo/util';

export function getSearchParams(
  selectedLocations?: LocationFilterValue,
  timeFilterValue?: TimeFilterValue
): string {
  const params = new URLSearchParams();

  if (selectedLocations && selectedLocations.values.length > 0) {
    const locationNames = selectedLocations.values.map((item) => item.name);
    params.append('locations', locationNames.join(SEPARATOR));
  }

  if (timeFilterValue && timeFilterValue.period !== TimePeriod.ALL_TIME) {
    if (timeFilterValue.period === TimePeriod.CUSTOM_RANGE) {
      const [startTime, endTime] = getStartEndTimes(timeFilterValue);
      if (startTime) {
        params.append('dateFrom', String(startTime));
      }
      if (endTime) {
        params.append('dateTo', String(endTime));
      }
    } else {
      const [minutes, hours] = getMHFromTimePeriod(timeFilterValue.period);
      if (hours) {
        params.append('relativeTimeHours', String(hours));
      }
      if (minutes) {
        params.append('relativeTimeMinutes', String(minutes));
      }
    }
  }

  return params.toString();
}
